<div class="clearfix" data-aos="fade-up" [attr.id]="complaintData ? 'data-ready-marker' : null">
  <div class="clearfix" id="pdf-content" style="padding: 20px; position: relative">
    <div class="pdf-section">
      <div class="mb-3 w-100">
        <div class="p-3 border rounded bg-light">
          <div class="row">
            <div class="col-md-3 mb-2">
              <label
                ><span id="complaint-id" class="font-weight-bold">Complaint ID</span>:
                {{ complaintId || '-' }}</label
              >
            </div>
            <div class="col-md-3 mb-2">
              <label
                ><span class="font-weight-bold">Case Type</span>: Complaint</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix border-box">
      <h5 class="Heading1 mb-0">Complainant Information</h5>
      <div class="border-body p-3">
        <div>
            <p>Please enter the name of the individual submitting this complaint. Only one complainant may be
                listed.
                If multiple people are involved, each person must submit their own separate complaint or be listed
                by the complainant as a witness if they have asked one person to submit on behalf of all parties.
            </p>
        </div>
        <div class="row">
          <div class="col-md-3 mb-3">
            <label class="form-label">Complainant Name<span class="text-red">*</span></label>
            <input
              type="text"
              class="form-control"
              [value]="complaintData?.strComplaintName || ''"
              placeholder="Enter First Name" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label">Complainant Email Address</label>
            <input
              type="text"
              class="form-control"
              [value]="complaintData?.strComplaintEmailAddress || ''"
              placeholder="Enter Email Address" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label">Complainant Phone Number</label>
            <input
              type="text"
              class="form-control"
              [value]="complaintData?.strComplaintMobileNumber || ''"
              placeholder="Enter Phone Number" />
          </div>
        </div>
        <hr/>
        <div class="row">
          <div class="col-md-3 mb-3">
            <label class="form-label">Complainant Street Address</label>
            <input
              type="tel"
              class="form-control"
              [value]="complaintData?.strComplaintStreetAddress || ''"
              placeholder="Enter Street Address" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label">City</label>
            <input
              type="text"
              class="form-control"
              [value]="complaintData?.strCdCity || ''"
              placeholder="Enter City" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label">State</label>
            <input
              type="text"
              class="form-control"
              [value]="complaintData?.strCdState || ''"
              placeholder="Enter State" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label">ZIP Code</label>
            <input
              type="text"
              class="form-control"
              [value]="complaintData?.strZipcode || ''"
              placeholder="Enter ZIP Code" />
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix border-box">
      <h5 class="Heading1 mb-0">Complaint Details</h5>
      <div class="border-body p-3">
        <div>
          <p>Please provide the details of your complaint. Include the educator’s name, the date(s), time(s),
            and a clear description of the alleged violation or concern. Provide as much information as you can
            to help the Department understand and investigate the issue.</p>
        </div>
        <div class="row">
          <div class="col-md-3 mb-3">
            <label class="form-label">Date of Incident</label>
            <input
              type="text"
              class="form-control"
              [value]="complaintData?.dtDateOfIncident"
              placeholder="Select Date of Incident" />
          </div>
          <div *ngIf="complaintData?.strEducatorName" class="col-md-3 mb-3">
            <label class="form-label">Educator Name</label>
            <input
              type="text"
              class="form-control"
              [value]="complaintData?.strEducatorName"
              placeholder="Enter Educator Name" />
          </div>
        </div>
        <div class="mt-3">
          <p>Brief Description of the Alleged Misconduct<span class="text-red">*</span>
          </p>
        </div>
        <div class=" mb-3 gap_education">
          <div class="card mt-3">
            <p-editor #complaintEditor 
              placeholder="Enter Description (Include dates, times, locations, and any relevant details)"
               [style]="{'height':'8rem'}">
            </p-editor>
          </div>
        </div>
      </div>
      <hr class="horizontal-line" />
      <div class="row header-row justify-content-between align-items-center m-3 mt-3 mb-3">
        <div class="w-padding">
          <span class="title" id="dashboard_title">Licensed Educator Details</span>
        </div>
        <div class="col-auto">
          <div class="actions d-flex">
            <div class="export-actions">
            </div>
            <div class="column-chooser-actions mr-3">
              <button mat-icon-button class="icon-btn" matTooltip="Column Chooser" matTooltipPosition="above"
                matTooltipClass="custom-tooltip" id="dashboard_column_chooser_btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                    fill="currentColor" />
                </svg>
              </button>
            </div>
            <button type="button" class="btn btn-primary grid rounded btn-add height_btn"
              aria-label="Add" tooltipPosition="bottom">
              <i class="pi pi-plus-circle"></i> Add</button>
          </div>
        </div>
      </div>
      <div class="m-3">
        <app-data-grid id="licenseEducatorGrid" [config]="licenseEducatorDataGridConfig"
          [actionsTemplateRef]="licenseEducatorActionsTemplate" [activeTab]="'background'">
            <ng-template #licenseEducatorActionsTemplate let-row let-index="index">
              <div class="action-buttons-container d-flex gap_action"
                [id]="'dashboard_div_actions_' + row.index">
                <div class="action-inline ml-4">
                  <div class="action-flex">
                    <!-- Delete button only for draft applications -->
                    <button mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                      matTooltipPosition="above" matTooltipClass="custom-tooltip"
                      [id]="'license_educator_delete_row_' + row.index">
                      <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" width="24"
                        height="24" class="filter-icon">
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
        </app-data-grid>
      </div>
    </div>
    <div class="license-wrapper border-box mb-3">
      <div class="clearfix border-box">
        <h5 class="Heading1 mb-0">Witnesses and Supporting Documentation</h5>
      </div>
      <div class="section-body p-3 border-box-section">
        <div>
          <p>List any witnesses or other individuals who have knowledge of the events described in your
            complaint. Include their contact information and a brief statement if available. You may also upload
            any documents, photos, or other evidence that supports your complaint.</p>
        </div>
       <div class="border-body p-3">
        <!-- witness data grid -->
         <div class="row">
          <div class="col-md-3 mb-3">
            <label class="form-label">Witness Name<span class="text-red">*</span></label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter Witness Name" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label">Witness Email Address</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter Witness Email Address" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label">Witness Phone Number</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter Witness Phone Number" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label">Street Address</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter Street Address" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 mb-3">
            <label class="form-label">City</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter City" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label">State</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter State" />
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label">Zip Code</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter Zip Code" />
          </div>
        </div>
        <div class="mt-3">
          <p>Additional Information
          </p>
        </div>
        <div class=" mb-3 gap_education">
          <div class="card mt-3">
            <p-editor  
              placeholder="Enter Additional Information"
               [style]="{'height':'8rem'}">
            </p-editor>
          </div>
        </div>
        <div class="d-flex justify-content-end licenseactions pl-3 mt-3">
          <button class="btn-cancel btn text-right py-1 height_btn"
            >Reset</button>
          <button type="button" class="btn btn-primary grid rounded btn-add height_btn"
             aria-label="Add" tooltipPosition="bottom">
            <i class="pi pi-plus-circle"></i> Add</button>
        </div>
      </div>
        <div class="column-chooser-actions mb-2 d-flex justify-content-end">
          <button mat-icon-button class="icon-btn" matTooltip="Column Chooser" matTooltipPosition="above"
            matTooltipClass="custom-tooltip" id="dashboard_column_chooser_btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
              <path
                d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                fill="currentColor" />
            </svg>
          </button>
        </div>
        <app-data-grid  [config]="witnessesDataGridConfig"
          [attr.data-key]="witnessesDataGridConfig._changeKey" [actionsTemplateRef]="dashboardActionTemplate"
          id="dashboard_grid_datagrid" class="no-border-grid">
          <ng-template #dashboardActionTemplate let-row let-index="index">
            <div class="action-buttons-container d-flex gap_action"
              [id]="'dashboard_div_actions_' + row.application_id">
              <div class="action-inline ml-4">
                <div class="action-flex">
                    <button type="button" class="action-icon-button" matTooltip="Edit" matTooltipPosition="above">
                    <svg width="24" height="24" viewBox="4 4 26 26" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M10.3077 25.501C9.80258 25.501 9.375 25.326 9.025 24.976C8.675 24.626 8.5 24.1984 8.5 23.6933V10.3087C8.5 9.80358 8.675 9.376 9.025 9.026C9.375 8.676 9.80258 8.501 10.3077 8.501H17.1598C17.4098 8.501 17.5973 8.5795 17.7223 8.7365C17.8473 8.89367 17.9098 9.06517 17.9098 9.251C17.9098 9.43683 17.8447 9.60833 17.7145 9.7655C17.5843 9.9225 17.3942 10.001 17.1442 10.001H10.3077C10.2307 10.001 10.1603 10.0331 10.0963 10.0972C10.0321 10.1612 10 10.2317 10 10.3087V23.6933C10 23.7703 10.0321 23.8407 10.0963 23.9047C10.1603 23.9689 10.2307 24.001 10.3077 24.001H23.6923C23.7692 24.001 23.8398 23.9689 23.9038 23.9047C23.9679 23.8407 24 23.7703 24 23.6933V16.7933C24 16.5433 24.0785 16.3558 24.2355 16.2308C24.3927 16.1058 24.5642 16.0433 24.75 16.0433C24.9358 16.0433 25.1073 16.1058 25.2645 16.2308C25.4215 16.3558 25.5 16.5433 25.5 16.7933V23.6933C25.5 24.1984 25.325 24.626 24.975 24.976C24.625 25.326 24.1974 25.501 23.6923 25.501H10.3077ZM14.5 18.597V16.8165C14.5 16.5753 14.5468 16.3436 14.6405 16.1212C14.734 15.8987 14.8628 15.7055 15.027 15.5415L23.5598 7.00875C23.7148 6.85358 23.8853 6.74042 24.0712 6.66925C24.2571 6.59808 24.4462 6.5625 24.6385 6.5625C24.8347 6.5625 25.0231 6.59808 25.2038 6.66925C25.3846 6.74042 25.5493 6.85033 25.698 6.999L26.9538 8.251C27.0986 8.40617 27.2098 8.57733 27.2875 8.7645C27.365 8.95167 27.4038 9.14142 27.4038 9.33375C27.4038 9.52608 27.3708 9.71258 27.3048 9.89325C27.2388 10.0741 27.1282 10.242 26.973 10.397L18.4115 18.9587C18.2473 19.1227 18.0541 19.2542 17.8318 19.353C17.6093 19.4517 17.3775 19.501 17.1365 19.501H15.404C15.1462 19.501 14.9311 19.4147 14.7588 19.2422C14.5863 19.0699 14.5 18.8548 14.5 18.597ZM16 18.001H17.2463L23.4788 11.7682L22.8558 11.1452L22.1885 10.503L16 16.6915V18.001Z"
                        fill="#444444" />
                    </svg>
                  </button>
                  <!-- Delete button only for draft applications -->
                  <button mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                    matTooltipPosition="above" matTooltipClass="custom-tooltip"
                    [id]="'dashboard_delete_row_' + row.application_id">
                    <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" width="24"
                      height="24" class="filter-icon">
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </app-data-grid>
        <!-- witness data grid -->
        <!-- supporting documents data grid -->
        <hr class="horizontal-line" />
        <div class="row header-row justify-content-between align-items-center mt-3 mb-3">
          <div class="w-padding m-3">
            <span class="title" id="dashboard_title">Supporting Documents</span>
          </div>
          <div class="col-auto">
            <div class="actions d-flex">
              <div class="export-actions">
              </div>
              <div class="column-chooser-actions">
                <button mat-icon-button class="icon-btn" matTooltip="Column Chooser" matTooltipPosition="above"
                  matTooltipClass="custom-tooltip"
                  id="dashboard_column_chooser_btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                      fill="currentColor" />
                  </svg>
                </button>
              </div>
                  <button type="button" class="btn btn-primary grid rounded upload-btn ml-2" aria-label="Upload"
                tooltipPosition="bottom"><img class="mr-2 width-20"
                  src="../../../../assets/images/neveda-images/upload.svg" alt="" srcset="">Upload</button>
            </div>
          </div>
        </div>
        <app-data-grid  [config]="supportingWitnessesDataGrid"
          [actionsTemplateRef]="dashboardActionTemplate1" id="dashboard_grid_datagrid">
          <ng-template #dashboardActionTemplate1 let-row let-index="index">
            <div class="action-buttons-container d-flex gap_action">
              <div class="action-inline ml-4">
                <div class="action-flex">
                  <button mat-icon-button class="action-icon-button" matTooltip="Download"
                    matTooltipPosition="above" matTooltipClass="custom-tooltip"
                    [id]="'dashboard_open_row_download_dialog_' + row.strFileName">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                      fill="none">
                      <path
                        d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
                        fill="currentColor" />
                    </svg>
                  </button>
                  <button mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                    matTooltipPosition="above" matTooltipClass="custom-tooltip"
                     [id]="'dashboard_delete_row_' + row.strFileName">
                    <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" class="filter-icon">
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </app-data-grid>
        <!-- supporting documents data grid -->
      </div>
    </div>
    <div class="license-wrapper border-box mb-3 ">
      <div class="clearfix border-box">
        <h5 class="Heading1 mb-0">Complaint Decision</h5>
      </div>
      <div class="justify-content-between d-flex p-3">
        <div class="row responsive-row">
            <div class="col-md-6  pl-1 pr-0 d-flex flex-column responsive-col">
              <label class="form-label">Complaint Status</label>
              <input
                type="text"
                class="form-control"
                [value]="complaintData.complaintStatusValue"
                placeholder="Enter Complaint Status" />
            </div>
            <div *ngIf="complaintData.assignee" class="col-md-6  pl-1 pr-0 d-flex flex-column responsive-col">
              <label class="form-label">Assign To</label>
              <input
                type="text"
                class="form-control"
                [value]="complaintData.assignToValue"
                placeholder="Enter Assign To" />
            </div>
          </div>
        <button type="button" class="btn btn-primary float-md-right mb-4 mt-2 rounded responsive-submit-btn"
          >Update Status</button>
      </div>
    </div>
     <div class="license-wrapper border-box mb-3 ">
      <div class="clearfix border-box">
        <h5 class="Heading1 mb-0">Complaint Archival</h5>
      </div>
      <div class="justify-content-between d-flex p-3">
        <div class="row responsive-row">
            <div class="pl-1 pr-0 d-flex flex-column responsive-col">
              <label class="form-label">Complaint Archival</label>
              <input
                type="text"
                class="form-control"
                [value]="complaintData.complaintArchivalStatusValue"
                placeholder="Enter Complaint Archival" />
            </div>
          </div>
        <button type="button" class="btn btn-primary float-md-right mb-4 mt-2 rounded responsive-submit-btn"
          >Update Status</button>
      </div>
    </div>
    <div class="license-wrapper border-box mb-3" >
      <div class="clearfix border-box">
        <h5 class="Heading1 mb-0">Notes</h5>  
      </div>
      <div class="p-3">
       <div class="col-lg-6 pl-1 pr-0 d-flex flex-column responsive-col">
          <label class="form-label">Section</label>
          <input
            type="text"
            class="form-control"
            placeholder="Select Section" />
        </div>
        <div class="form-group position-relative mt-3">
            <label for="input_fingerprint_form_note">Notes</label>
            <textarea type="text" id="input_fingerprint_form_note" 
                class="form-control" rows="3" placeholder="Enter Notes" maxlength="4000"></textarea>
        </div>
        <div class="d-flex justify-content-end licenseactions pl-3 mt-3 mb-5">
          <button class="btn-cancel btn text-right py-1 height_btn" tooltipPosition="bottom"
            >Reset</button>
          <button type="button" class="btn btn-primary grid rounded btn-add height_btn"
            aria-label="Add" tooltipPosition="bottom">
            <i class="pi pi-plus-circle"></i> Add</button>
        </div>
        <app-data-grid id="complaintNotesGrid" [config]="complaintNotesGridConfig"
           [activeTab]="'background'">
          <ng-template  let-row let-index="index">
            <div class="action-buttons-container"
              [id]="'dashboard_div_actions_' + row.index">
              <span class="action-span-wrapper">
                  <button mat-icon-button class="action-icon-button ml-2" matTooltip="Edit"
                    matTooltipPosition="above" matTooltipClass="custom-tooltip"
                    [id]="'complaint_notes_edit_row_' + row.index">
                    <img src="../../assets/images/neveda-images/edit-icon.svg" alt="Edit" width="24"
                      height="24" class="filter-icon">
                  </button>
              </span>
              <span class="action-span-wrapper">
                  <button mat-icon-button class="action-icon-button ml-2" matTooltip="View"
                    matTooltipPosition="above" matTooltipClass="custom-tooltip"
                    [id]="'complaint_notes_view_row_' + row.index">
                    <img src="../../assets/images/neveda-images/eye.svg" alt="View" width="24"
                      height="24" class="filter-icon">
                  </button>
              </span>
              <span class="action-span-wrapper">
                  <button  mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                    matTooltipPosition="above" matTooltipClass="custom-tooltip"
                    [id]="'complaint_notes_delete_row_' + row.index">
                    <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" width="24"
                      height="24" class="filter-icon">
                  </button>
              </span>
            </div>
          </ng-template>
        </app-data-grid>
      </div>
  </div>
  </div>
</div>
